export default process.env.BUILD_TARGET === 'server'
